import React from "react";
import { Search, ChevronDown, ChevronLeft, ChevronRight } from 'lucide-react';
import { getAllCalendarData } from "../../models/calendar";
import i18n from "../../i18n";
import { getLoggedUser } from "../../state/user";
import { getAllAuctions } from "../../models/auctions";
import { SaudiRiyalLogo } from "../logo/saudiLogo";
import { formatCurrency } from "../../state/utils";

const user = getLoggedUser();

const HomeBanner = ({ callbackForSupport }) => (
    <div className="hero-banner">
        <div className="hero-content">
            <h1 className="hero-title">{i18n.t('auction_calendar')}</h1>
        </div>
    </div>
);

export class AuctionCalendarNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            eventsList: [],
            currentMonth: new Date(),
            selectedDate: new Date(),
            searchTerm: '',
            selectedSeller: 'Seller',
            selectedLocation: 'Location',
            loading: true
        };

        this.getAllData = this.getAllData.bind(this);
        this.navigateMonth = this.navigateMonth.bind(this);
        this.goToToday = this.goToToday.bind(this);
        this.selectDate = this.selectDate.bind(this);
        this.handleSelectEvent = this.handleSelectEvent.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        // if (user && user.id) {
        this.getAllData();
        // }
    }

    createDate(dt) {
        if (!dt) return null;
        if (dt instanceof Date) return dt;
        return new Date(dt.replace ? dt.replace(/-/g, "/") : dt);
    }

    async getAllData() {
        this.setState({ loading: true });
        try {
            console.log("response");
            const response = await getAllCalendarData();
            console.log(response);
            if (response.success) {
                this.setState({
                    eventsList: response.data.map(event => ({
                        ...event,
                        start: this.createDate(event.start),
                        end: this.createDate(event.end)
                    })),
                    loading: false
                });
            }
        } catch (error) {
            console.error('Failed to load calendar data:', error);
            this.setState({ loading: false });
        }
    }

    handleSelectEvent(event) {
        window.location.href = "/auction-details/" + event.data.id;
    }

    getMonthDays = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth();

        // First day of the month
        const firstDay = new Date(year, month, 1);
        // Last day of the month
        const lastDay = new Date(year, month + 1, 0);

        // Start from the first Monday of the week that contains the first day
        const startDay = new Date(firstDay);
        const dayOfWeek = firstDay.getDay();
        const diff = firstDay.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
        startDay.setDate(diff);

        // End at the last Sunday of the week that contains the last day
        const endDay = new Date(lastDay);
        const lastDayOfWeek = lastDay.getDay();
        const diffEnd = lastDay.getDate() + (7 - lastDayOfWeek) - (lastDayOfWeek === 0 ? 7 : 0);
        endDay.setDate(diffEnd);

        const days = [];
        const current = new Date(startDay);

        while (current <= endDay) {
            days.push(new Date(current));
            current.setDate(current.getDate() + 1);
        }

        return days;
    };

    formatMonthYear = (date) => {
        return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
    };

    getAuctionsForDate = (date) => {
        return this.state.eventsList.filter(event => {
            const eventDate = new Date(event.start);
            return eventDate.toDateString() === date.toDateString();
        });
    };

    navigateMonth = (direction) => {
        const newMonth = new Date(this.state.currentMonth);
        newMonth.setMonth(newMonth.getMonth() + (direction === 'next' ? 1 : -1));
        this.setState({ currentMonth: newMonth });
    };

    goToToday = () => {
        const today = new Date();
        this.setState({
            currentMonth: today,
            selectedDate: today
        });
    };

    selectDate = (date) => {
        this.setState({ selectedDate: date });
    };

    isCurrentMonth = (date) => {
        return date.getMonth() === this.state.currentMonth.getMonth() &&
            date.getFullYear() === this.state.currentMonth.getFullYear();
    };

    isToday = (date) => {
        const today = new Date();
        return date.toDateString() === today.toDateString();
    };



    getSidebarAuctions = () => {
        const selectedDateAuctions = this.getAuctionsForDate(this.state.selectedDate);
        return selectedDateAuctions.slice(0, 6).map(auction => ({
            id: auction.data?.id || auction.id || 'N/A',
            title: auction.title,
            reg_start_date: auction.data.reg_start_date,
            reg_end_date: auction.data.reg_end_date,
            start_date: auction.data.start_date,
            end_date: auction.data.end_date,
            guarantee_amount: auction.data.guarantee_amount,
            start_amount: auction.data.start_amount,

        }));
    };

    getMonthStats = () => {
        const monthEvents = this.state.eventsList.filter(event => {
            const eventDate = new Date(event.start);
            return eventDate.getMonth() === this.state.currentMonth.getMonth() &&
                eventDate.getFullYear() === this.state.currentMonth.getFullYear();
        });

        return {
            totalAuctions: monthEvents.length,
            totalDays: new Set(monthEvents.map(event => new Date(event.start).toDateString())).size
        };
    };

    render() {
        const monthDays = this.getMonthDays(this.state.currentMonth);
        const weeks = [];

        // Group days into weeks (7 days per week)
        for (let i = 0; i < monthDays.length; i += 7) {
            weeks.push(monthDays.slice(i, i + 7));
        }

        const selectedDateAuctions = this.getAuctionsForDate(this.state.selectedDate);
        const sidebarAuctions = this.getSidebarAuctions();
        const monthStats = this.getMonthStats();



        const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

        const styles = {
            container: {
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                backgroundColor: '#f8fafc',
                minHeight: '100vh',
                padding: '20px 0'
            },
            header: {
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '12px',
                marginBottom: '20px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                maxWidth: '1200px',
                margin: '0 auto 20px'
            },
            title: {
                fontSize: '28px',
                fontWeight: '600',
                color: '#1e293b',
                marginBottom: '20px'
            },
            searchBar: {
                display: 'flex',
                gap: '12px',
                alignItems: 'center',
                flexWrap: 'wrap'
            },
            searchContainer: {
                position: 'relative',
                flex: '1',
                minWidth: '200px'
            },
            searchInput: {
                width: '100%',
                padding: '10px 12px 10px 40px',
                border: '1px solid #d1d5db',
                borderRadius: '8px',
                fontSize: '14px'
            },
            searchIcon: {
                position: 'absolute',
                left: '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#6b7280',
                zIndex: 1
            },
            dropdown: {
                padding: '10px 12px',
                border: '1px solid #d1d5db',
                borderRadius: '8px',
                backgroundColor: 'white',
                fontSize: '14px',
                color: '#6b7280',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                minWidth: '120px'
            },
            mainContent: {
                maxWidth: '1300px',
                margin: '0 auto',
                padding: '0 20px'
            },
            calendarSection: {
                backgroundColor: 'white',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            },
            calendarHeader: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '20px',
                borderBottom: '1px solid #e5e7eb'
            },
            navButton: {
                background: 'none',
                border: 'none',
                padding: '8px',
                borderRadius: '6px',
                cursor: 'pointer',
                color: '#6b7280',
                transition: 'all 0.2s ease'
            },
            todayButton: {
                backgroundColor: '#189398',
                color: 'white',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '6px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                margin: '0 15px'
            },
            monthTitle: {
                fontSize: '24px',
                fontWeight: '600',
                color: '#1e293b'
            },
            monthStats: {
                display: 'flex',
                gap: '20px',
                marginTop: '10px'
            },
            statItem: {
                fontSize: '14px',
                color: '#6b7280'
            },
            calendarGrid: {
                display: 'grid',
                gridTemplateColumns: 'repeat(7, 1fr)',

            },
            dayHeader: {
                padding: '15px 10px',
                textAlign: 'center',
                borderBottom: '1px solid #e5e7eb',
                fontSize: '14px',
                fontWeight: '600',
                color: '#374151',
                backgroundColor: '#f9fafb'
            },
            dayCell: {
                minHeight: '90px',
                border: '1px solid #e5e7eb',
                padding: '8px',
                position: 'relative',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                backgroundColor: 'white'
            },
            dayCellOtherMonth: {
                backgroundColor: '#f9fafb',
                color: '#9ca3af'
            },
            dayCellToday: {
                backgroundColor: '#dbeafe',
                border: '2px solid #3b82f6'
            },
            dayCellSelected: {
                backgroundColor: 'rgba(24, 147, 152 , 0.3)',
                border: '2px solid #0369a1'
            },
            dayNumber: {
                fontSize: '14px',
                fontWeight: '600',
                marginBottom: '5px'
            },
            auctionBadge: {
                color: 'white',
                fontSize: '10px',
                fontWeight: '600',
                padding: '2px 6px',
                borderRadius: '4px',
                margin: '1px 0',
                display: 'block',
                cursor: 'pointer',
                transition: 'transform 0.1s ease',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            },
            auctionCount: {
                position: 'absolute',
                top: '5px',
                right: '5px',
                backgroundColor: '#ef4444',
                color: 'white',
                borderRadius: '50%',
                width: '20px',
                height: '20px',
                fontSize: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '600'
            },
            sidebar: {
                backgroundColor: 'white',
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                height: 'fit-content',
                marginLeft: '10px'
            },
            sidebarHeader: {
                fontSize: '20px',
                fontWeight: '600',
                color: '#1e293b',
                marginBottom: '5px'
            },
            sidebarDate: {
                fontSize: '14px',
                color: '#6b7280',
                marginBottom: '20px'
            },
            auctionItem: {
                borderBottom: '1px solid #f1f5f9',
                padding: '12px 0',
                cursor: 'pointer',
                transition: 'background-color 0.2s ease'
            },
            auctionId: {
                fontSize: '14px',
                fontWeight: '600',
                color: '#1e293b',
                marginBottom: '4px'
            },
            auctionTitle: {
                fontSize: '13px',
                color: '#6b7280',
                marginBottom: '8px'
            },
            auctionTitle2: {
                fontSize: '13px',
                color: 'black',
                marginBottom: '2px'
            },
            auctionType: {
                display: 'inline-block',
                padding: '4px 8px',
                borderRadius: '4px',
                fontSize: '11px',
                fontWeight: '600',
                color: 'white'
            },
            noEvents: {
                textAlign: 'center',
                color: '#9ca3af',
                fontStyle: 'italic',
                padding: '20px'
            },
            loadingContainer: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '400px',
                fontSize: '16px',
                color: '#6b7280'
            }
        };

        // let auction = this.auction;
        // let current_lng = localStorage.getItem("I18N_LANGUAGE");

        // let startDateAr = auction.start_date_ar;
        // let endDateAr = auction.end_date_ar;

        // let statusAr = auction.status_label;
        // let disp_status = "";
        // let statusClass = this.getStatusBadgeClass(statusAr?.status);

        // if (statusAr && statusAr["status"]) {
        //     disp_status = current_lng === "ar" ? statusAr["ar"] : statusAr["en"];
        // }

        // let endTime = new Date(this.createDate(auction.start_date)).getTime();
        // let aucEndTime = new Date(this.createDate(auction.end_date)).getTime();

        // let end_time = endDateAr && endDateAr["time"] ? endDateAr["time"] : "";
        // end_time = end_time.replace("PM", i18n.t("PM"));
        // end_time = end_time.replace("AM", i18n.t("AM"));

        // let start_time = startDateAr && startDateAr["time"] ? startDateAr["time"] : "";
        // start_time = start_time.replace("PM", i18n.t("PM"));
        // start_time = start_time.replace("AM", i18n.t("AM"));

        return (
            <React.Fragment>
                <HomeBanner callbackForSupport={this.props.callbackForSupport} />
                <div className="main-content">
                    <div style={styles.container}>

                        <div className="row gap-2" style={styles.mainContent}>
                            {/* Calendar */}
                            <div className="col-md-7" style={styles.calendarSection}>
                                <div style={styles.calendarHeader}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }} dir="ltr">
                                        <button
                                            style={styles.navButton}
                                            onClick={() => this.navigateMonth('prev')}
                                            onMouseOver={(e) => e.target.style.backgroundColor = '#f3f4f6'}
                                            onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
                                        >
                                            <ChevronLeft size={24} />
                                        </button>
                                        <div style={{ textAlign: 'center' }}>
                                            <div style={styles.monthTitle}>
                                                {this.formatMonthYear(this.state.currentMonth)}
                                            </div>
                                            <div style={styles.monthStats}>
                                                <div style={styles.statItem}>
                                                    {monthStats.totalAuctions} auctions
                                                </div>
                                                <div style={styles.statItem}>
                                                    {monthStats.totalDays} days with auctions
                                                </div>
                                            </div>
                                        </div>
                                        <button
                                            style={styles.navButton}
                                            onClick={() => this.navigateMonth('next')}
                                            onMouseOver={(e) => e.target.style.backgroundColor = '#f3f4f6'}
                                            onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
                                        >
                                            <ChevronRight size={24} />
                                        </button>
                                    </div>

                                    <div style={{ width: '100px' }}></div> {/* Spacer for alignment */}
                                </div>

                                {/* Day Headers */}
                                <div style={styles.calendarGrid} >
                                    {dayNames.map((dayName, index) => (
                                        <div key={index} style={styles.dayHeader}>
                                            {dayName}
                                        </div>
                                    ))}
                                </div>

                                {/* Calendar Grid */}
                                {this.state.loading ? (
                                    <div style={styles.loadingContainer}>
                                        {i18n.t('loading_auction')}
                                    </div>
                                ) : (
                                    <div style={styles.calendarGrid} >
                                        {monthDays.map((day, index) => {
                                            const isCurrentMonth = this.isCurrentMonth(day);
                                            const isToday = this.isToday(day);
                                            const isSelected = day.toDateString() === this.state.selectedDate.toDateString();
                                            const dayAuctions = this.getAuctionsForDate(day);

                                            const dayStyle = {
                                                ...styles.dayCell,
                                                ...(!isCurrentMonth && styles.dayCellOtherMonth),
                                                ...(isToday && styles.dayCellToday),
                                                ...(isSelected && styles.dayCellSelected)
                                            };

                                            return (
                                                <div
                                                    key={index}
                                                    style={dayStyle}
                                                    onClick={() => this.selectDate(day)}
                                                    dir="ltr"
                                                >
                                                    <div style={styles.dayNumber}>
                                                        {day.getDate()}
                                                    </div>
                                                    {dayAuctions.length > 0 && (
                                                        <div style={styles.auctionCount}>
                                                            {dayAuctions.length}
                                                        </div>
                                                    )}
                                                    <div style={{ maxHeight: '70px', overflowY: 'auto' }}>
                                                        {dayAuctions.length > 3 && (
                                                            <div style={{
                                                                fontSize: '10px',
                                                                color: '#6b7280',
                                                                textAlign: 'center',
                                                                marginTop: '2px'
                                                            }}>
                                                                +{dayAuctions.length - 3} more
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>

                            {/* Sidebar */}
                            <div className="col-md-4" style={styles.sidebar}>
                                <div style={styles.sidebarHeader}>
                                    {i18n.t('selected_date')}
                                </div>
                                <div style={styles.sidebarDate}>
                                    {this.state.selectedDate.toLocaleDateString('en-US', {
                                        weekday: 'long',
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric'
                                    })}
                                </div>

                                {selectedDateAuctions.length > 0 ? (
                                    sidebarAuctions.map((auction, index) => (
                                        <div
                                            key={index}
                                            style={styles.auctionItem}
                                            onClick={() => {
                                                const fullAuction = this.state.eventsList.find(a =>
                                                    (a.data?.id || a.id) === auction.id
                                                );
                                                if (fullAuction) this.handleSelectEvent(fullAuction);
                                            }}

                                        >
                                            <div style={styles.auctionId}>      <a
                                                target="_blank"
                                                href={`https://www.google.com/maps?q=${auction.latitude},${auction.longitude}`}
                                                style={{ fontSize: "14px", marginRight: "6px" }}
                                                className={`interaction-btn-modern ${this.state.wishlist ? 'active' : ''}`}
                                            >
                                                <i className="fa fa-location-arrow"></i>
                                            </a> MZADSA{auction.id} </div>
                                            <div style={styles.auctionTitle}>{auction.title}</div>


                                            <div className="row">


                                                <div className="col-6">
                                                    <h6 style={styles.auctionTitle2}> {i18n.t('registration_start')}</h6>
                                                          <h6 style={styles.auctionTitle}>  {new Date(this.createDate(auction.reg_start_date)).toLocaleDateString('en-GB', {
                                                        day: '2-digit',
                                                        month: 'short',
                                                        year: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit'
                                                    })}</h6>

                                                </div>

                                                <div className="col-6">
                                                    <h6 style={styles.auctionTitle2}> {i18n.t('registration_end')}</h6>
                                                     <h6 style={styles.auctionTitle}>  {new Date(this.createDate(auction.reg_end_date)).toLocaleDateString('en-GB', {
                                                        day: '2-digit',
                                                        month: 'short',
                                                        year: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit'
                                                    })}</h6>
                                                </div>

                                                <div className="col-6">
                                                    <h6 style={styles.auctionTitle2}> {i18n.t('start_date')}</h6>

                                                    <h6 style={styles.auctionTitle}>  {new Date(this.createDate(auction.start_date)).toLocaleDateString('en-GB', {
                                                        day: '2-digit',
                                                        month: 'short',
                                                        year: 'numeric',
                                                        hour: '2-digit',
                                                        minute: '2-digit'
                                                    })}</h6>
                                                </div>
                                                <div className="col-6">
                                                    <h6 style={styles.auctionTitle2}> {i18n.t('end_date')} </h6>
                                                    <h6 style={styles.auctionTitle}>
                                                        {new Date(this.createDate(auction.end_date)).toLocaleDateString('en-GB', {
                                                            day: '2-digit',
                                                            month: 'short',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit'
                                                        })}
                                                    </h6>                                                </div>



                                                <div className="col-6">
                                                    <h6 style={styles.auctionTitle2}> {i18n.t('gurantee_amount')}</h6>
                                                    <h6 style={styles.auctionTitle}>{formatCurrency(auction.guarantee_amount)} <SaudiRiyalLogo /> </h6>
                                                </div>
                                                <div className="col-6">
                                                    <h6 style={styles.auctionTitle2}> {i18n.t('start_bid_amount')}</h6>
                                                    <h6 style={styles.auctionTitle}>{formatCurrency(auction.start_amount)} <SaudiRiyalLogo /> </h6>
                                                </div>
                                            </div>

                                        </div>
                                    ))
                                ) : (
                                    <div style={styles.noEvents}>
                                        No auctions scheduled for this date
                                    </div>
                                )}

                                {/* <div style={{
                                    fontSize: '11px',
                                    color: '#9ca3af',
                                    fontStyle: 'italic',
                                    marginTop: '20px',
                                    paddingTop: '20px',
                                    borderTop: '1px solid #f1f5f9'
                                }}>
                                    *Auction schedule can be subject to change.
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}